document.addEventListener("DOMContentLoaded", () => {
  const destiniWrapper = document.querySelector('#destini-omni-wrapper');

  document.addEventListener('click', (e) => {
    const destini_btn = e.target.closest('[data-open-destini]');
    if (!destini_btn) return;

    const apo = destini_btn.getAttribute('data-destini-apo');
    const host = document.querySelector('.destini-locator-class');

    if (!host) {
      console.warn('[Destini] host element not found');
      return;
    }

    if (apo) {
      host.setAttribute('data-apo', apo);
    }

    if (!host.shadowRoot) {
      console.warn('[Destini] shadow root not found');
      return;
    }

    const chakraButton = host.shadowRoot.querySelector('.chakra-button');

    const clickAndObserve = (btn) => {
      btn.click();

      // Inject custom styles into shadow DOM
      if (!host.shadowRoot.querySelector('#destini-custom-styles')) {
        const style = document.createElement('style');
        style.id = 'destini-custom-styles';
        style.textContent = `
          h1.chakra-text {
            font-family: NewKansas, Figtree, sans-serif !important;
          }
        `;
        host.shadowRoot.appendChild(style);
      }

      const locatorContainer = host.shadowRoot.querySelector('#locator-template-container');
      if (!locatorContainer) {
        console.warn('[Destini] locator-template-container not found');
        return;
      }

      const portal = locatorContainer.querySelector('.chakra-portal');
      if (!portal) {
        console.warn('[Destini] portal not found inside locator-template-container');
        return;
      }

      const portalObserver = new MutationObserver(() => {
        if (portal.children.length > 0) {
          destiniWrapper.style.display = 'block';
        } else {
          destiniWrapper.style.display = 'none';
        }
      });

      portalObserver.observe(portal, { childList: true });
    };

    if (chakraButton) {
      clickAndObserve(chakraButton);
    } else {
      const observer = new MutationObserver(() => {
        const btn = host.shadowRoot.querySelector('.chakra-button');
        if (btn) {
          observer.disconnect();
          clickAndObserve(btn);
        }
      });
      observer.observe(host.shadowRoot, { childList: true, subtree: true });
    }
  });
});